import { FormControl, Stack, Typography } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { Formik, Form as FormikForm } from "formik";
import { Mail } from "lucide-react";
import * as yup from "yup";

import { postForgotPassword } from "api/user";
import { ForgotPasswordPayloadType } from "api/user/types";
import FormikTextField from "components/forms/FormikTextField";
import UltimateButton from "components/UltimateButton";

const ForgotPasswordForm = () => {
  const initialValues = {
    email: "",
  };

  const schema = yup.object({
    email: yup.string().email("Wrong email format").required(),
  });

  const { mutateAsync: forgotPassword, isLoading } = useMutation(
    async (values: ForgotPasswordPayloadType) => {
      const res = await postForgotPassword(values);
      return res.data;
    },
  );

  const handleSubmit = async (values: ForgotPasswordPayloadType) => {
    await forgotPassword(values);
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={handleSubmit}
    >
      <FormikForm>
        <Stack spacing={2}>
          <FormControl fullWidth>
            <Typography variant="body2" fontWeight={600} mb={0.5}>
              Email
            </Typography>
            <FormikTextField name="email" placeholder="you@company.com" />
          </FormControl>

          <UltimateButton
            type="submit"
            text="Send Reset Link"
            loading={isLoading}
            Icon={
              Mail as React.ComponentType<{
                size?: number;
                className?: string;
                style?: React.CSSProperties;
              }>
            }
            sx={{ mt: 1, py: 1 }}
          />
        </Stack>
      </FormikForm>
    </Formik>
  );
};

export default ForgotPasswordForm;
